(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-slider')) {
    class HeroSlider extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        clearTimeout(this.timer);

        this.track = this.querySelector('[data-track]');
        if (!this.track) return;

        this.slides = Array.from(this.track.querySelectorAll('[data-hero-slide]')).filter(
          (slide) => slide.closest('hero-slider') === this
        );
        this.count = this.slides.length;
        this.current = 0;
        this.delay = Number(this.dataset.speed) || 5000;
        this.autoplay = this.dataset.autoplay === 'true' && !window.Shopify?.designMode;
        this.userPaused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.hoverHold = false;
        this.focusHold = false;
        this.editorHold = false;
        this.abort = new AbortController();

        this.slides.forEach((slide, i) => {
          slide.setAttribute('aria-label', `${i + 1} / ${this.count}`);
          slide.style.transform = '';
          this.setSlideState(slide, i === 0);
        });

        const controls = this.querySelector('[data-controls]');
        if (this.count < 2) {
          if (controls) controls.hidden = true;
          return;
        }
        if (controls) controls.hidden = false;

        this.buildDots();
        this.bindEvents();
        this.schedule();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.abort?.abort();
      }

      get isRTL() {
        return getComputedStyle(this).direction === 'rtl';
      }

      setSlideState(slide, active) {
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
        slide.querySelectorAll('video').forEach((video) => {
          if (active) video.play().catch(() => {});
          else video.pause();
        });
      }

      buildDots() {
        const wrap = this.querySelector('[data-dots]');
        this.dots = [];
        if (!wrap) return;
        wrap.replaceChildren();
        const label = this.dataset.labelSlide || 'Go to slide';
        this.dots = this.slides.map((_, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'hero-slider__dot';
          dot.setAttribute('aria-label', `${label} ${i + 1}`);
          dot.setAttribute('aria-current', String(i === 0));
          dot.addEventListener('click', () => this.goTo(i), { signal: this.abort.signal });
          wrap.appendChild(dot);
          return dot;
        });
      }

      bindEvents() {
        const { signal } = this.abort;

        this.querySelector('[data-prev]')?.addEventListener('click', () => this.step(-1), { signal });
        this.querySelector('[data-next]')?.addEventListener('click', () => this.step(1), { signal });

        // Pause on hover and keyboard focus
        this.addEventListener('pointerenter', (e) => {
          if (e.pointerType === 'mouse') this.hold('hoverHold', true);
        }, { signal });
        this.addEventListener('pointerleave', (e) => {
          if (e.pointerType === 'mouse') this.hold('hoverHold', false);
        }, { signal });
        this.addEventListener('focusin', (e) => {
          if (e.target.matches(':focus-visible')) this.hold('focusHold', true);
        }, { signal });
        this.addEventListener('focusout', (e) => {
          if (!this.contains(e.relatedTarget)) this.hold('focusHold', false);
        }, { signal });
        document.addEventListener('visibilitychange', () => this.schedule(), { signal });

        // Keyboard arrows
        this.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          if (e.target.matches('input, textarea, select')) return;
          const forward = (e.key === 'ArrowRight') !== this.isRTL;
          this.step(forward ? 1 : -1);
        }, { signal });

        // Swipe
        let startX = 0;
        let startY = 0;
        let tracking = false;
        let swiped = false;

        this.track.addEventListener('pointerdown', (e) => {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          tracking = true;
          swiped = false;
          startX = e.clientX;
          startY = e.clientY;
        }, { signal });

        this.track.addEventListener('pointerup', (e) => {
          if (!tracking) return;
          tracking = false;
          const dx = e.clientX - startX;
          const dy = e.clientY - startY;
          if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy)) return;
          swiped = true;
          const forward = (dx < 0) !== this.isRTL;
          this.step(forward ? 1 : -1);
        }, { signal });

        this.track.addEventListener('pointercancel', () => {
          tracking = false;
        }, { signal });

        // Block link clicks that end a swipe
        this.track.addEventListener('click', (e) => {
          if (!swiped) return;
          e.preventDefault();
          e.stopPropagation();
          swiped = false;
        }, { capture: true, signal });

        // Theme editor: jump to the selected slide
        this.addEventListener('shopify:block:select', (e) => {
          const slide = e.target.closest?.('[data-hero-slide]');
          const index = this.slides.indexOf(slide);
          if (index === -1) return;
          this.editorHold = true;
          this.goTo(index);
        }, { signal });

        this.addEventListener('shopify:block:deselect', () => {
          this.editorHold = false;
          this.schedule();
        }, { signal });
      }

      hold(key, value) {
        this[key] = value;
        this.schedule();
      }

      step(dir) {
        this.goTo(this.current + dir, dir);
      }

      goTo(target, dir) {
        const index = (target + this.count) % this.count;
        if (index === this.current) return this.schedule();

        const direction = dir ?? (index > this.current ? 1 : -1);
        const prev = this.slides[this.current];
        const next = this.slides[index];

        if (this.dataset.transition === 'slide') {
          const d = direction * (this.isRTL ? -1 : 1);
          next.style.transition = 'none';
          next.style.transform = `translateX(${d * 100}%)`;
          void next.offsetWidth;
          next.style.transition = '';
          next.style.transform = 'translateX(0)';
          prev.style.transform = `translateX(${-d * 100}%)`;
        }

        this.setSlideState(prev, false);
        this.setSlideState(next, true);
        this.current = index;
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
        this.schedule();
      }

      schedule() {
        clearTimeout(this.timer);
        if (
          !this.autoplay ||
          this.userPaused ||
          this.hoverHold ||
          this.focusHold ||
          this.editorHold ||
          document.hidden ||
          this.count < 2
        ) return;
        this.timer = setTimeout(() => this.step(1), this.delay);
      }
    }

    customElements.define('hero-slider', HeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
